// extracted by mini-css-extract-plugin
export default {"beta-btn":"BetaButton_beta-btn__Baq1Q"};